import React, { createContext, useState, useContext, ReactNode } from 'react';

type ContatoProps = {
    "descricao": string,
    "tipoContatoId": string,
    "url": string,
    "telefone": string,
    "imageUrl": string
}

type ContatoContextProps = {
    contatos: ContatoProps[],
    setContatos: React.Dispatch<React.SetStateAction<ContatoProps[]>>
}

const ContatoContext = createContext<ContatoContextProps>({} as any);

export const ContatoProvider = ({ children }: { children: ReactNode }) => {
    const [contatos, setContatos] = useState<ContatoProps[]>([]);

    return (
        <ContatoContext.Provider value={{contatos, setContatos}}>
            {children}
        </ContatoContext.Provider>
    );
};

export const useContato = () => useContext(ContatoContext);